<template>
    <div>
        <div class="list-group-item col-xs-12 resurs-info" :class="{ active: selected && isActive }">
            <div>
                <span style="font-weight: bold;">{{ resursPaymentOption.name }}</span>
                <span v-if="resursPaymentOption.code != '0'" class="pull-right" style="font-weight: bold;">{{ monthlyCost }} / mån</span>
            </div>
            <div v-if="selected">
                <ul>
                    <li>{{ resursPaymentOption.interestRate }}% ränta</li>
                    <li>{{ setupFee }} uppläggningsavgift</li>
                    <li>{{ administrationFee }} administrationsavgift</li>
                </ul>
                <ul class="part-payment-info">
                    <li>Första Betalning efter nästa lön</li>
                    <li>Betala av när du vill</li>
                    <li>Enkel översikt i Resurs app</li>
                </ul>
                <ul>
                    <li>Effektiv ränta {{ resursPaymentOption.effectiveInterestRate }}% med betalning över {{ resursPaymentOption.durationMonths }} månader.</li>
                    <li>Totalkostnad {{ totalCost }}</li>
                </ul>
                 <ul>
                    <li><a target="_blank" :href="resursPaymentOption.priceInfoUrl">Fullständiga villkor och SEKKI</a></li>
                </ul>
            </div>
        </div>
        <div v-if="! isLastRow" class="col-xs-12 border-bottom"></div>
    </div>
</template>
<script>
import { formatPrice } from 'utils';

export default {
    props: {
        resursPaymentOption: {
			type: Object
		},
        isLastRow: {
            type: Boolean
        },
        isActive: {
            type: Boolean
        },
        selectedResursPaymentMethodId: {
            type: String
        },
        index: {
            type: Number
        },
        totalCartSum: {
            type: Number
        }
    },
    data() {
        return {

        }
    },
    computed: {
        selected () {
            return this.selectedResursPaymentMethodId == this.resursPaymentOption.code;
        },
        totalCost () {
            return formatPrice(this.resursPaymentOption.totalCost, 'SEK');
        },
        monthlyCost () {
            return formatPrice(this.resursPaymentOption.monthlyCost, 'SEK');
        },
        setupFee () {
            return formatPrice(this.resursPaymentOption.setupFee, 'SEK');
        },
        administrationFee () {
            return formatPrice(this.resursPaymentOption.administrationFee, 'SEK');
        }
    }
}
</script>
